import type { ProductType } from "../redux/actions/productAction";

/** Model / part number shown in online-order UI (never internal productCode). */
export function resolveOnlineOrderLineModelCode(
  row: Record<string, unknown>,
  productByCode: Map<string, ProductType>,
  productById: Map<number, ProductType>,
): string | undefined {
  const fromRow = row.modelNumber ?? row.model_number;
  if (fromRow != null && String(fromRow).trim() !== "") {
    return String(fromRow).trim();
  }

  const pcode = String(row.productCode ?? "");
  const id = Number(row.productId);
  const catalog =
    (pcode ? productByCode.get(pcode) : undefined) ??
    (id && !Number.isNaN(id) ? productById.get(id) : undefined);
  const model = catalog?.modelNumber;
  if (model != null && String(model).trim() !== "") {
    return String(model).trim();
  }

  return undefined;
}

export function resolveOnlineOrderLineProductName(
  row: Record<string, unknown>,
  productByCode: Map<string, ProductType>,
  productById: Map<number, ProductType>,
): string {
  const name = row.productName != null ? String(row.productName).trim() : "";
  if (name) return name;

  const pcode = String(row.productCode ?? "");
  const id = Number(row.productId);
  const fromCatalog =
    (pcode ? productByCode.get(pcode)?.productName : undefined) ??
    (id && !Number.isNaN(id) ? productById.get(id)?.productName : undefined);
  if (fromCatalog?.trim()) return fromCatalog.trim();

  return "—";
}

export function lineProductLabel(
  row: Record<string, unknown>,
  productByCode: Map<string, ProductType>,
  productById: Map<number, ProductType>,
): { name: string; code?: string } {
  return {
    name: resolveOnlineOrderLineProductName(row, productByCode, productById),
    code: resolveOnlineOrderLineModelCode(row, productByCode, productById),
  };
}
